module.exports = __webpack_public_path__ + "img/quali1.b978ad56.jpg";